<template>
    <div class="text-xs-center">
      <v-layout row wrap>

<div v-for="(item, i) in items" :key="i" class="thumbnail">
  <img :src="item.thumbnail | removeProtocol" class="portrait" alt="Image" />
</div>
      </v-layout>
  </div>
</template>
<script>
  export default {
    name: 'templatesThumbs',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    data () {
      return {

      };
    },
    methods: {
    },
    filters: {
      removeProtocol (url) {
        return url.replace(/(^\w+:|^)\/\//, '//');
      }
    }
  };
</script>
<style>
.thumbnail {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border: solid 1px #dbdbdb;
  margin: 10px;
}
.thumbnail img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
          transform: translate(-50%,-50%);
}
.thumbnail img.portrait {
  width: 100%;
  height: auto;
}
</style>
